import React from "react";
import Card from "react-bootstrap/Card";
import "bootstrap/dist/css/bootstrap.min.css";
import PropTypes from "prop-types";
import tickIcon from "../../assets/icons/Icon.svg";
import CheckboxIcon from "../../assets/icons/Checkmark.svg";   
import CheckboxCheckedIcon from "../../assets/icons/Check-box.svg"; 
import { getSafeImageSrc } from "../../utils/utils";


const StepCard = ({ number, image, body, isSelected, onClick, isVh }) => {
  const isClinicalService =
    localStorage.getItem("selectedService") === "clinical";

  if (isVh) {
    return (
      <div className="col-md-6 d-flex align-items-center gap-3 mb-3">
        <img
          alt=""
          aria-checked={!!isSelected}
          aria-label={`Confirm step ${number}`}
          onClick={onClick}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
          role="checkbox"
          src={isSelected ? CheckboxCheckedIcon : CheckboxIcon}
          tabIndex={0}
        />
        <Card className="vh-step-card flex-grow-1 rounded-0" onClick={onClick}>
          <Card.Body className="d-flex align-items-center justify-content-between gap-3">
            <div>
              <h3>Step {number}</h3>
              <p className="mb-0">{body}</p>
            </div>
            <img
              alt={`confirmation step icon ${number}`}
              src={getSafeImageSrc(image)}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div
      className={`${isClinicalService ? "col-md-3" : "col-md-2"} test-confirmation-col`}
    >
      <Card
        className={`test-confirmation-card ${isClinicalService && "clinical-card-shadow"} ${isSelected && "active-card"}`}
        onClick={onClick}
        tabIndex={0}
        onKeyDown={onClick}
      >
        <div className={`step-number ${isSelected && "active-card"}`}>
          {isSelected ? <img src={tickIcon} alt="success-icon" /> : number}
        </div>
        <Card.Body>
          <div className='step-img'>
            <img alt={`confirmation step icon ${number}`} src={getSafeImageSrc(image)} />
          </div>
          <div className={`${isClinicalService && "step-card-content"}`}>
            {body}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

StepCard.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  image: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  isVh: PropTypes.bool,
};

export default StepCard;